import React from 'react';
import { useTranslation } from 'react-i18next';
import Hospital from '../assets/images/market-healthcare-real.jpg';
import Laundromat from '../assets/images/market-laundries-real.jpg';
import Carwash from '../assets/images/market-carwash-real-v2.jpg';
import Vineyard from '../assets/images/market-agriculture-real.jpg';
import Condominium from '../assets/images/market-condominiums-real.jpg';
import Industry from '../assets/images/market-industry-real.jpg';

const markets = [
  { id: 'condominiums', image: Condominium },
  { id: 'laundries', image: Laundromat },
  { id: 'hospitals', image: Hospital },
  { id: 'industries', image: Industry },
  { id: 'carWashes', image: Carwash },
  { id: 'agriculture', image: Vineyard },
];

function Applications() {
  const { t } = useTranslation();

  return (
    <section className="markets-section" id="Applications" aria-labelledby="applications-title">
      <div className="section-container">
        <header className="section-heading markets-heading">
          <p className="section-eyebrow">{t('applications.eyebrow')}</p>
          <h2 id="applications-title">{t('applications.title')}</h2>
          <p>{t('applications.introduction')}</p>
        </header>

        <div className="markets-grid">
          {markets.map((market) => (
            <article className="market-card" key={market.id}>
              <img
                src={market.image}
                width="350"
                height="300"
                loading="lazy"
                alt={t(`applications.items.${market.id}.imageAlt`)}
              />
              <div className="market-card__content">
                <h3>{t(`applications.items.${market.id}.title`)}</h3>
                <p>{t(`applications.items.${market.id}.description`)}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Applications;
